var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7594 20.6727C26.7594 24.0427 24.0275 26.7746 20.6576 26.7746C17.2876 26.7746 14.5557 24.0427 14.5557 20.6727C14.5557 17.3027 17.2876 14.5708 20.6576 14.5708C24.0275 14.5708 26.7594 17.3027 26.7594 20.6727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0813 11.52C16.9239 11.52 17.6069 10.8369 17.6069 9.99437C17.6069 9.15179 16.9239 8.46875 16.0813 8.46875C15.2387 8.46875 14.5557 9.15179 14.5557 9.99437C14.5557 10.8369 15.2387 11.52 16.0813 11.52Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6069 31.3513C17.6069 32.1939 16.9239 32.8769 16.0813 32.8769C15.2387 32.8769 14.5557 32.1939 14.5557 31.3513C14.5557 30.5087 15.2387 29.8257 16.0813 29.8257C16.9239 29.8257 17.6069 30.5087 17.6069 31.3513Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2346 11.52C26.0772 11.52 26.7602 10.8369 26.7602 9.99437C26.7602 9.15179 26.0772 8.46875 25.2346 8.46875C24.392 8.46875 23.709 9.15179 23.709 9.99437C23.709 10.8369 24.392 11.52 25.2346 11.52Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7602 31.3513C26.7602 32.1939 26.0772 32.8769 25.2346 32.8769C24.392 32.8769 23.709 32.1939 23.709 31.3513C23.709 30.5087 24.392 29.8257 25.2346 29.8257C26.0772 29.8257 26.7602 30.5087 26.7602 31.3513Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6584 11.52C21.501 11.52 22.184 10.8369 22.184 9.99437C22.184 9.15179 21.501 8.46875 20.6584 8.46875C19.8159 8.46875 19.1328 9.15179 19.1328 9.99437C19.1328 10.8369 19.8159 11.52 20.6584 11.52Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.184 31.3513C22.184 32.1939 21.501 32.8769 20.6584 32.8769C19.8159 32.8769 19.1328 32.1939 19.1328 31.3513C19.1328 30.5087 19.8159 29.8257 20.6584 29.8257C21.501 29.8257 22.184 30.5087 22.184 31.3513Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94287 20.4399H10.2856L9.54834 19.4012L11.1793 18.2437L13.5454 21.5775L11.1638 24.7527L9.56386 23.5526L10.3984 22.4399H7.94287V31.9977H5.94287V20.4399Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8172 12.9184V20.4879H29.0078V22.4879H34.8172V12.8748L35.8829 13.674L37.0828 12.0739L33.9071 9.69247L30.5732 12.0584L31.7308 13.6895L32.8172 12.9184Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3443 0H0V41.3443H41.3443V0ZM2 39.3443V2H39.3443V39.3443H2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateLibrary);
export default __webpack_public_path__ + "static/media/TemplateLibrary.142e0eaea2b0bbf5acff9176b93b705a.svg";
export { ForwardRef as ReactComponent };